// extracted by mini-css-extract-plugin
export default {"wrapperBox":"RePaginate_wrapperBox__BZAOO","wrapper":"RePaginate_wrapper__kL+BB","icon":"RePaginate_icon__JWNwW","text":"RePaginate_text__z-Owd"};